import { type BEResponsePagedResponseNotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/bEResponsePagedResponseNotificaResponseDTO.ts';
import { type BEResponsePagedResponseNotificaUtenteResponseDTO } from '@framework/api-client/api/inquiries-compile/schemas/bEResponsePagedResponseNotificaUtenteResponseDTO.ts';
import dayjs from 'dayjs';
import produce from 'immer';
import { useQueryClient } from 'react-query';
import { useNotificationsContext } from '../context/NotificationsContext.tsx';

export function useSetReadNotification(notificationId: string) {
  const { useMarkAsRead, getGetNotificationsQueryKey } =
    useNotificationsContext();

  const NotificationsApiKey = getGetNotificationsQueryKey()[0] as string; // "/notifiche"

  const queryClient = useQueryClient();
  const mutationOptions = {
    mutation: {
      onMutate: () => {
        queryClient.cancelQueries(NotificationsApiKey);

        // https://github.com/TanStack/query/issues/599#issuecomment-647586208
        const notificationQueriesData = queryClient.getQueriesData<
          | BEResponsePagedResponseNotificaResponseDTO
          | BEResponsePagedResponseNotificaUtenteResponseDTO
        >(NotificationsApiKey);
        notificationQueriesData.forEach(([key]) => {
          queryClient.setQueryData<
            | BEResponsePagedResponseNotificaResponseDTO
            | BEResponsePagedResponseNotificaUtenteResponseDTO
          >(key, response => setNotificationAsRead(response, notificationId));
        });
      },
      onError: (context: any) => {
        // In caso ci sia stato un errore, prima ripristiniamo le notifiche
        // di quello eliminato..
        queryClient.setQueryData(context.key, context.previousData);
        // ..e dopo ricarichiamo dal backend
        queryClient.invalidateQueries(NotificationsApiKey);
      },
    },
  };

  return useMarkAsRead(mutationOptions);
}

function setNotificationAsRead(
  response:
    | BEResponsePagedResponseNotificaResponseDTO
    | BEResponsePagedResponseNotificaUtenteResponseDTO
    | undefined,
  notificationId: string,
) {
  return produce(response ?? {}, draft => {
    const notification = draft?.data?.list?.find(n => n.id === notificationId);
    if (notification) {
      notification.dataPresaVisione = dayjs().toDate().toString();
    }
    return draft;
  });
}
